import React, { useState } from 'react'
import PropTypes from 'prop-types';
import './styles.css';
import cloneDeep from 'lodash/cloneDeep'

const CheckboxOrRadioGroup = ({
  directionRow,
  options,
  optionsObjectList,
  name,
  controlFunc,
  selectedOptions,
  multiSelect = false,
  checkboxStyles,
  wrapperStyles,
  labelStyles,
  type,
}) => {
  const [selected, setSelected] = useState(selectedOptions);
  const onChange = (e) => {
    if (!multiSelect) {
      setSelected(e.target.value)
      if (controlFunc) controlFunc(e);
    } else {
      const opts = cloneDeep(selected)
      if (e.target.checked && !opts.includes(e.target.value)) {
        opts.push(e.target.value)
      } else {
        opts.splice(opts.indexOf(e.target.value), 1)
      }
      setSelected(opts)
      if (controlFunc) {
        // e.target.value = opts;
        controlFunc(opts)
      }
    }
  }
  return (
    <div
      className={
        directionRow
          ? 'checkbox-or-radiogroup__wrapper checkbox-or-radiogroup__wrapper--row'
          : 'checkbox-or-radiogroup__wrapper'
      }
      style={wrapperStyles}
    >
      {options
        ? options.map((opt, index) => (
          <label
            key={index}
            className="checkbox-or-radiogroup__label"
            style={labelStyles}
          >
            <input
              className="checkbox-or-radiogroup"
              name={name}
              onChange={onChange}
              value={opt}
              checked={!multiSelect ? selected === opt : selected.includes(opt)}
              type={type}
            />
            <span className="checkbox-or-radiogroup__checkmark"/>
            {opt}
          </label>
        ))
        : optionsObjectList.map((opt, index) => (
          <label key={index} className="checkbox-or-radiogroup__label">
            <input
              className="checkbox-or-radiogroup"
              name={name}
              onChange={onChange}
              value={opt.value}
              checked={!multiSelect ? selected === opt.value : selected.includes(opt.value)}
              type={type}
            />
            <span
              className="checkbox-or-radiogroup__checkmark"
              style={checkboxStyles}
            />
            {opt.label && opt.label}
            {opt.image && (
              <img
                className="checkbox-or-radiogroup__image"
                src={opt.image}
                alt="checkbox"
              />
            )}
          </label>
        ))}
    </div>
  )
};

CheckboxOrRadioGroup.propTypes = {
  type: PropTypes.oneOf(['checkbox', 'radio']).isRequired,
  name: PropTypes.string.isRequired,
  options: PropTypes.array,
  optionsObjectList: PropTypes.array,
  selectedOptions: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array
  ]),
  controlFunc: PropTypes.func,
  directionRow: PropTypes.bool,
  multiSelect: PropTypes.bool,
  wrapperStyles: PropTypes.object,
  labelStyles: PropTypes.object,
};

export default CheckboxOrRadioGroup;
